import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
      access_token: '',
      id_token:'',
      user: {}
    },
    mutations: {
      add_access_token (state, token) {
        state.access_token = token;
      },
      remove_access_token (state, token) {
        state.access_token = token;
      },
      add_id_token (state, token) {
        state.id_token = token;
      },
      remove_id_token(state){
        state.id_token = '';
      },
      add_user(state,user){
        state.user = user;
      },
      remove_user(state){
        state.user = {};
      }
    },
    plugins: [createPersistedState()]
  }); 
  
  export default store